export const fastCasinoGameDevelopmentServicesTextContent = {
  headingText: (
    <>
      <span>Diverse Benefits of Choosing Our</span>{" "}
      <span>Fast Casino Game Development Services</span>
    </>
  ),
  content: [
    {
      iconSrc: "/assets/stock-img/casino_game_development_img_01.webp",
      titleText: "Mobile Adaptive",
      paraText: "Our fast casino game software comes with provably fair games that are mobile responsive.",
    },
    {
      iconSrc: "/assets/stock-img/casino_game_development_img_02.webp",
      titleText: "Cost efficient",
      paraText: "Our AR/ VR Fast Casino games are highly cost effective which helps you get the games within your pre-decided budget.",
    },
    {
      iconSrc: "/assets/stock-img/casino_game_development_img_03.webp",
      titleText: "Customizations",
      paraText: "We provide customized fast casino game solutions that fit your business needs.",
    },
    {
      iconSrc: "/assets/stock-img/casino_game_development_img_04.webp",
      titleText: "100% Fair",
      paraText: "Our fast casino contains provably fair games the outcome of which can be verified seamlessly.",
    },
    {
      iconSrc: "/assets/stock-img/casino_game_development_img_05.webp",
      titleText: "Enhanced Privacy",
      paraText: "Our white label fast casino game development services offer you support of various cryptocurrencies.",
    },
    {
      iconSrc: "/assets/stock-img/casino_game_development_img_06.webp",
      titleText: "On-time delivery",
      paraText: "With the help of our fast casino game development services, you get your fast casino game software delivered on time.",
    },
  ],
};
